import React from 'react';
import axiosInstance from './axios-instance.js';

import Tile from './Tile.js'
import Button from './Button.js'
import TextBox from './TextBox.js'
import ConfirmableButton from './ConfirmableButton.js';
import LevelSelector from './LevelSelector.js';
import SelectedTile from './SelectedTile.js';


import { imageForServerLabel } from './label-lookups';

export default class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();

    this.updateName = this.updateName.bind(this);
    this.updateWidthText = this.updateWidthText.bind(this);
    this.updateHeightText = this.updateHeightText.bind(this);
    
    this.updateTickCountText = this.updateTickCountText.bind(this);
    this.updateSecondsBetweenTicksText = this.updateSecondsBetweenTicksText.bind(this);

    this.resetToDefaultState = this.resetToDefaultState.bind(this);
    this.loadSelectedLevel = this.loadSelectedLevel.bind(this);
    this.updateLevelSelection = this.updateLevelSelection.bind(this);
  }

  getDefaultState() {
    const defaultWidth = 5;
    const defaultHeight = 5;
    let tileData = new Array(defaultWidth).fill(null).map(() => new Array(defaultHeight).fill(null));

    for (let i = 0; i < defaultWidth; i++) {
      for (let j = 0; j < defaultHeight; j++) {
        // TODO: This whole thing is begging to be refactored into a thing where all the game objects
        // have one generic format that has an image and a type (as well as _possibly_ an orientation).
        // Then a tile could just have an array of game objects instead of this whole "two attributes for
        // every possible type of thing that could belong in a grid cell" approach.
        tileData[i][j] = this.getDefaultTileData();
      }
    }

    return {
      tiles: tileData,
      parameters: {
        width: 5,
        height: 5
      },
      widthText: "5",
      heightText: "5",
      tickCountText: "10",
      secondsBetweenTicksText: "10",
      mapName: '',
      selectedLevelName: undefined,
      saveValidationErrors: []
    };
  }

  getDefaultTileData() {
    return {
      image: '/images/zero-64.png',
      orientation: 'UP',
      tileType: 'zero',
      actorType: null,
      actorImage: null,
      itemType: null,
      itemImage: null,
      enemyType: null,
      enemyImage: null
    };
  }

  resetToDefaultState() {
    this.setState(this.getDefaultState());
  }

  componentDidMount() {
    this.fetchLevels();
  }

  fetchLevels() {
    axiosInstance.get(`level_names`).then((response) => {
      const options = response.data.level_names.map((levelName) => {
        return <option value={levelName}>
            {levelName}
          </option>;
      });

      this.setState({ levelSelectOptions: options });
      
      if (options[0]) {
        this.setState( { selectedLevelName: options[0].props.value });
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  loadSelectedLevel() {
    axiosInstance.get(`levels/${this.state.selectedLevelName}`).then((response) => {
      // TODO: These default values should live somewhere else and this should be handled more thoroughly if a parameter
      // is missing from the server response (or possibly throw an error)
      let width = 5;
      let height = 5;

      if (response.data.levelData.parameters !== undefined && response.data.levelData.parameters.width !== undefined) {
        width = response.data.levelData.parameters.width;
      }

      if (response.data.levelData.parameters !== undefined && response.data.levelData.parameters.height !== undefined) {
        height = response.data.levelData.parameters.height;
      }

      let tileData = new Array(width).fill(null).map(() => new Array(height).fill(null));

      for (const tile of response.data.levelData.tiles) {
        tileData[tile.coordinates.x][height - tile.coordinates.y - 1] = {
          image: imageForServerLabel(tile.type),
          orientation: tile.orientation,
          tileType: tile.type
        };
      }
      
      // TODO More DRY
      if (response.data.levelData.actors !== undefined) {
        for (const actor of response.data.levelData.actors) {
          tileData[actor.coordinates.x][height - actor.coordinates.y - 1].actorType = actor.type;
          tileData[actor.coordinates.x][height - actor.coordinates.y - 1].actorImage = imageForServerLabel(actor.type);
        }
      }

      if (response.data.levelData.items !== undefined) {
        for (const item of response.data.levelData.items) {
          tileData[item.coordinates.x][height - item.coordinates.y - 1].itemType = item.type;
          tileData[item.coordinates.x][height - item.coordinates.y - 1].itemImage = imageForServerLabel(item.type);
        }
      }

      if (response.data.levelData.enemies !== undefined) {
        for (const enemy of response.data.levelData.enemies) {
          tileData[enemy.coordinates.x][height - enemy.coordinates.y - 1].enemyType = enemy.type;
          tileData[enemy.coordinates.x][height - enemy.coordinates.y - 1].enemyImage = imageForServerLabel(enemy.type);
        }
      }

      let tickCountText = 10;
      if (response.data.levelData.parameters !== undefined && response.data.levelData.parameters.tickCount !== undefined) {
        tickCountText = response.data.levelData.parameters.tickCount;
      }

      let secondsBetweenTicksText = 10;
      if (response.data.levelData.parameters !== undefined && response.data.levelData.parameters.secondsBetweenTicks !== undefined) {
        secondsBetweenTicksText = response.data.levelData.parameters.secondsBetweenTicks;
      }

      this.setState({
        tiles: tileData,
        parameters: { 
          width: width,
          height: height,
        },
        widthText: width.toString(),
        heightText: height.toString(),
        tickCountText: tickCountText,
        secondsBetweenTicksText: secondsBetweenTicksText,
        mapName: response.data.name
      });

      console.log(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
  }
  
  updateLevelSelection(name) {
    this.setState( { selectedLevelName: name } );
  }

  updateTile(row, column) {
    const tileDataCopy = new Array(this.state.parameters.width);
    for (let i = 0; i < tileDataCopy.length; i++) {
      tileDataCopy[i] = this.state.tiles[i].slice(0);
    }

    // Pick different data to update based on what's clicked
    // TODO: Refactor everything so "tile type" is something like "room"
    // or "item" or "actor" and the current definition of "tiletype" is renamed
    // to something like "room type"
    // TODO 2: DRY all of this up
    let newData;
    if (this.props.selectedTileType === 'playerStart') {
      // TODO: Do not let this be placed on the exit
      if (tileDataCopy[row][column].tileType !== 'exit') {

        // Clear old player start if it already exists
        for (let i = 0; i < this.state.parameters.width; i++) {
          for (let j = 0; j < this.state.parameters.height; j++) {
            if (tileDataCopy[i][j].actorType === 'playerStart') {
              tileDataCopy[i][j].actorType = null;
              tileDataCopy[i][j].actorImage = null;
            }
          }
        }

        newData = {
          actorType: this.props.selectedTileType,
          actorImage: this.props.selectedImage
        };
      }
    }
    else if (this.props.selectedTileType === 'key') {
      // TODO: Do not let this be placed on the exit
      if (tileDataCopy[row][column].tileType !== 'exit') {
        // Clear old key if it already exists
        for (let i = 0; i < this.state.parameters.width; i++) {
          for (let j = 0; j < this.state.parameters.height; j++) {
            if (tileDataCopy[i][j].itemType === 'key') {
              tileDataCopy[i][j].itemType = null;
              tileDataCopy[i][j].itemImage = null;
            }
          }
        }

        newData = {
          itemType: this.props.selectedTileType,
          itemImage: this.props.selectedImage
        };
      }
    }
    else if (this.props.selectedTileType === 'spotter') {
      newData = {
        enemyType: this.props.selectedTileType,
        enemyImage: this.props.selectedImage
      };
    }
    else if (this.props.selectedTileType === 'removeEnemy') {
      newData = {
        enemyType: null,
        enemyImage: null
      }
    }
    else if (this.props.selectedTileType === 'exit') {
      const itemType = tileDataCopy[row][column].itemType;
      const actorType = tileDataCopy[row][column].actorType;
      if ((itemType === null || itemType === undefined) && (actorType === null || actorType === undefined)) {
        // Clear old exit if it already exists
        for (let i = 0; i < this.state.parameters.width; i++) {
          for (let j = 0; j < this.state.parameters.height; j++) {
            if (tileDataCopy[i][j].tileType === 'exit') {
              tileDataCopy[i][j].image = '/images/zero-64.png';
              tileDataCopy[i][j].orientation = 'UP';
              tileDataCopy[i][j].tileType = 'zero';
            }
          }
        }

        newData = { 
          image: this.props.selectedImage,
          orientation: this.props.selectedOrientation,
          tileType: this.props.selectedTileType
        };
      }
    }
    else {
      newData = { 
        image: this.props.selectedImage,
        orientation: this.props.selectedOrientation,
        tileType: this.props.selectedTileType
      };
    }
    
    tileDataCopy[row][column] = Object.assign({}, tileDataCopy[row][column], newData);
    
    this.setState({
      tiles: tileDataCopy
    });
  }

  updateName(name) {
    this.setState({
      mapName: name
    });
  }

  updateWidth() {
    const newWidth = parseInt(this.state.widthText);
    const oldWidth = this.state.parameters.width;

    this.setState((state, props) => ({
      parameters: {
        width: newWidth,
        height: state.parameters.height
      }
    }));

    let newTileData = new Array(newWidth).fill(this.getDefaultTileData())
      .map(() => new Array(this.state.parameters.height).fill(this.getDefaultTileData()));
    
    const maxWidth = Math.min(oldWidth, newWidth);

    for (let i = 0; i < maxWidth; i++) {
      for (let j = 0; j < this.state.parameters.height; j++) {
        newTileData[i][j] = this.state.tiles[i][j];
      }
    }

    this.setState({
      tiles: newTileData
    });
  }

  updateHeight() {
    const newHeight = parseInt(this.state.heightText);
    const oldHeight = this.state.parameters.height;

    this.setState((state, props) => ({
      parameters: {
        width: state.parameters.width,
        height: newHeight
      }
    }));

    let newTileData = new Array(this.state.parameters.width).fill(this.getDefaultTileData())
      .map(() => new Array(newHeight).fill(this.getDefaultTileData()));
    const maxHeight = Math.min(oldHeight, newHeight);

    for (let i = 0; i < this.state.parameters.width; i++) {
      for (let j = 0; j < maxHeight; j++) {
        newTileData[i][j] = this.state.tiles[i][j];
      }
    }

    this.setState({
      tiles: newTileData
    });
  }

  updateWidthText(width) {
    this.setState({
      widthText: width
    });
  }

  updateHeightText(height) {
    this.setState({
      heightText: height
    });
  }

  updateTickCountText(tickCount) {
    this.setState({
      tickCountText: tickCount
    });
  }

  updateSecondsBetweenTicksText(secondsBetweenTicks) {
    this.setState({
      secondsBetweenTicksText: secondsBetweenTicks
    });
  }

  saveMap() {
    let tilesToSave = [];
    let actorsToSave = [];
    let itemsToSave = [];
    let enemiesToSave = [];

    let playerStartPresent = false;
    let exitPresent = false;
    let keyPresent = false;

    for (let i = 0; i < this.state.parameters.width; i++) {
      for (let j = 0; j < this.state.parameters.height; j++) {
        // "Flip" y coordinates to match what's going on w/the client
        const currentTile = {
          coordinates: {
            x: i,
            y: this.state.parameters.height - j - 1
          },
          type: this.state.tiles[i][j].tileType,
          orientation: this.state.tiles[i][j].orientation
        }
        tilesToSave.push(currentTile);

        if (currentTile.type === 'exit') {
          exitPresent = true;
        }

        // TODO DRY
        if (!!this.state.tiles[i][j].actorType) {
          const currentActor = {
            coordinates: {
              x: i,
              y: this.state.parameters.height - j - 1
            },
            type: this.state.tiles[i][j].actorType
          };
          actorsToSave.push(currentActor);

          if (currentActor.type === 'playerStart') {
            playerStartPresent = true;
          }
        }

        if (!!this.state.tiles[i][j].itemType) {
          const currentItem = {
            coordinates: {
              x: i,
              y: this.state.parameters.height - j - 1
            },
            type: this.state.tiles[i][j].itemType
          };
          itemsToSave.push(currentItem);

          if (currentItem.type === 'key') {
            keyPresent = true;
          }
        }

        if (!!this.state.tiles[i][j].enemyType) {
          const currentEnemy = {
            coordinates: {
              x: i,
              y: this.state.parameters.height - j - 1
            },
            type: this.state.tiles[i][j].enemyType
          };
          enemiesToSave.push(currentEnemy);
        }
      }
    }

    const validations = [];
    // TODO: Convert validation to a generic component
    if (!playerStartPresent) {
      validations.push(<p className="validation">Add a player start before saving!</p>);
    }
    if (!keyPresent) {
      validations.push(<p className="validation">Add a key before saving!</p>);
    }
    if (!exitPresent) {
      validations.push(<p className="validation">Add an exit before saving!</p>)
    }

    this.setState({
      saveValidationErrors: validations
    });

    if (validations.length > 0) {
      return;
    }

    const parameters = {
      width: this.state.parameters.width,
      height: this.state.parameters.height,
      tickCount: parseInt(this.state.tickCountText),
      secondsBetweenTicks: parseInt(this.state.secondsBetweenTicksText)
    };

    const mapData = {
      level: {
        version: "0",
        name: this.state.mapName,
        levelData: {
          parameters: parameters,
          tiles: tilesToSave,
          actors: actorsToSave,
          items: itemsToSave,
          enemies: enemiesToSave
        }
      }
    };

    axiosInstance.post(`levels`, mapData).then((response) => {
      console.log(response);
      this.fetchLevels();
      this.setState({selectedLevelName: response.data.name})
    });
  }

  render() {
    // This is a little wonky because the tile 2D array goes by column then row, but HTML
    // does this by row then column.

    // Get all of the row indices by creating a range from 0 to the length of the first 
    // element in the tiles array (i.e. the first column)
    const rowIndices = [...Array(this.state.parameters.height)].map((_, i) => i );
    const columnIndices = [...Array(this.state.parameters.width)].map((_, i) => i );

    const tiles = rowIndices.map((rowIndex) => {
      const cells = columnIndices.map((columnIndex) => {
        const tile = this.state.tiles[columnIndex][rowIndex];

        const image = tile.image;
        const orientation = tile.orientation;
        const actorImage = tile.actorImage;
        const itemImage = tile.itemImage;
        const enemyImage = tile.enemyImage;

        return(
          <td>
            <Tile
              image={image}
              orientation={orientation}
              onClick={() => this.updateTile(columnIndex, rowIndex)}
              actorImage={actorImage}
              itemImage={itemImage}
              enemyImage={enemyImage}
            />
          </td>
        );
      })

      return (
        <tr>{cells}</tr>
      );
    });

    const saveClickHandler = () => this.saveMap();

    const levelUrl = `http://${process.env.REACT_APP_GAME_CLIENT_URL}?level=${this.state.mapName}`

    return(
      <div className="map">
        <h1>{this.state.mapName !== "" ? this.state.mapName : "Map"}</h1>
        <table>
          <tbody>
            {tiles}
          </tbody>
        </table>
        
        {this.props.selectedImage && false && 
          <SelectedTile
            image={this.props.selectedImage}
            orientation={this.props.selectedOrientation} />
        }

        <div className="update-width">
          <Button onClick={() => this.updateWidth()} text="Update Width" />
          <TextBox textValue={this.state.widthText} onTextChange={this.updateWidthText} />
        </div>

        <div className="update-height">
          <Button onClick={() => this.updateHeight()} text="Update Height" />
          <TextBox textValue={this.state.heightText} onTextChange={this.updateHeightText} />
        </div>

        <div className="update-tick-count">
          <span>Number of timer ticks</span>
          <TextBox textValue={this.state.tickCountText} onTextChange={this.updateTickCountText} />
        </div>

        <div className="update-seconds-between-ticks">
          <span>Seconds between each timer tick</span>
          <TextBox textValue={this.state.secondsBetweenTicksText} onTextChange={this.updateSecondsBetweenTicksText} />
        </div>

        <div className="save-map">
          <Button onClick={saveClickHandler} text="Save Map" />
          <TextBox textValue={this.state.mapName} onTextChange={this.updateName} />
          <div className="save-validations">{this.state.saveValidationErrors}</div>
        </div>

        <hr />

        <div className="reset-map">
          <ConfirmableButton
            buttonText="Reset Map"
            confirmationAction={this.resetToDefaultState}
          />
        </div>

        <hr />

        <div className="load-map">
          <LevelSelector
            loadLevel={this.loadSelectedLevel}
            selectedLevelName={this.state.selectedLevelName}
            updateLevelSelection={this.updateLevelSelection}
            selectOptions={this.state.levelSelectOptions}
          />
        </div>
        
        <hr />

        <div className="play-map">
          <a href={levelUrl} target="_blank" rel="noreferrer">Play!</a>
        </div>
      </div>
    );
  }
}
